/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfoLink_user$ref = any;
export type PdpSharedBlurbShipping_user$ref = any;
export type PdpSharedBlurbShipping_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": PdpSharedShippingInfoLink_user$ref;
    readonly " $refType": PdpSharedBlurbShipping_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_user",
      "args": null
    }
  ]
};
(node as any).hash = '692ffbf80bf5c2738dee5a2bebd95949';
export default node;
